import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { styled } from "../../theme";
import { TextField, isValueFilled } from "../text-field";
/**
 * A formik field for password input with a visibility toggle.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered password field component.
 */
export const PasswordField = (props) => {
    const [type, setType] = useState("password");
    return (_jsx(TextField, { ...props, type: type, renderAfter: field => isValueFilled(field.value) && (_jsx(VisibilityToggle, { onClick: () => setType(type === "password" ? "text" : "password"), children: type === "password" ? "Show" : "Hide" })) }));
};
const VisibilityToggle = styled.div `
  display: flex;
  justify-content: end;
  margin-inline-end: 0.625rem;
  padding-block: 0.875rem;
  width: 3.875rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${({ theme }) => theme.color.darkBlue40};
  cursor: pointer;
  text-transform: uppercase;
  user-select: none;
`;
